module.exports = __webpack_public_path__ + "img/giftcard_expired.c9e03df4.svg";